import { Pipe, PipeTransform } from "@angular/core";
import { ReviewTypeEnum } from "../enums/review-type.enum";
import { ReviewPeriodHelper } from "../helpers/review-period.helper";
import { ReviewPeriodForEmployee } from "../models/review-period-for-employee.model";
import { ReviewPeriodStatusEnum } from "../enums/review-period-status.enum";
import { DateHelper } from "../shared/helpers";
import { AssessmentService, ReviewPeriodService } from "../services";
import { TranslateService } from "@ngx-translate/core";

@Pipe({name: 'assessmentStatus'})
export class AssessmentStatusPipe implements PipeTransform {

  constructor(private reviewPeriodService: ReviewPeriodService, private assessmentService: AssessmentService, private translate: TranslateService) {

  }

  transform(item: ReviewPeriodForEmployee) {
      if (item.reviewPeriod.reviewType === ReviewTypeEnum.TER) {

        if (item.reviewPeriod.isPositionBasedAssessment || item.reviewPeriod.isSpecialQuestionSetBasedAssessment)
        {
          if (DateHelper.isPlainTodayBetween(item.reviewPeriod.panoramaAuraStartDate, item.reviewPeriod.panoramaAuraEndDate) || ReviewPeriodHelper.isRpClosed(item.reviewPeriod))
            return this.reviewPeriodService.getStatusName(item.reviewPeriod.status);
          else
            return this.translate.instant('ASSESSMENT_PIPE.OUTSIDE_DEADLINE');
        }
        else if (item.reviewPeriod.isGoalsEnabled) {
          if (DateHelper.isPlainTodayBetween(item.reviewPeriod.goalsStartDate, item.reviewPeriod.goalsEndDate) || ReviewPeriodHelper.isRpClosed(item.reviewPeriod))
            return this.reviewPeriodService.getStatusName(item.reviewPeriod.status);
          else
            return this.translate.instant('ASSESSMENT_PIPE.OUTSIDE_DEADLINE');
        }
      }
      // else if (!item.reviewPeriodEmployee) {

      // }
      else
      {
        if (item.reviewPeriod.status != ReviewPeriodStatusEnum.Open)
          return this.reviewPeriodService.getStatusName(item.reviewPeriod.status);
        else
          return this.assessmentService.getStatusName(item.reviewPeriodEmployee.status);
      }

  }
}

@Pipe({name: 'assessmentStatusName'})
export class AssessmentStatusNamePipe implements PipeTransform {

  constructor(private assessmentService: AssessmentService) {
    
  }

  transform(value?: number) {
    if (!value) return '';
    return this.assessmentService.getStatusName(value);
  }
}
